import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import {
  Check as CheckIcon,
  CheckAll as CheckAllIcon,
  Clock as ClockIcon,
} from "mdi-material-ui";
import { formatDistance, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export const ChatTimeViewer: FC<{
  isMe: boolean;
  createdAt: string;
  wait: boolean;
  send: boolean;
  viewed: boolean;
}> = ({ isMe, createdAt, send, viewed, wait }) => {
  return (
    <Typography
      variant="caption"
      sx={(theme) => ({
        color: isMe
          ? theme.palette.getContrastText(theme.palette.primary.main)
          : "inherit",
      })}
    >
      {formatDistance(parseISO(createdAt), Date.now(), {
        addSuffix: true,
        locale: ptBR,
      })}
      {isMe && (
        <Box component="span" sx={{ verticalAlign: "middle", pl: 0.5 }}>
          {wait && <ClockIcon fontSize="inherit" />}
          {send && <CheckIcon fontSize="inherit" />}
          {viewed && <CheckAllIcon fontSize="inherit" />}
        </Box>
      )}
    </Typography>
  );
};
